import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const authAxios = axios.create({ baseURL: API, withCredentials: true });

// ---- Estimates ----
export const getAIEstimate = async (payload) => {
  const res = await axios.post(`${API}/estimate/ai`, payload);
  return res.data;
};

// ---- Waitlist ----
export const joinWaitlist = async (email) => {
  const res = await axios.post(`${API}/waitlist`, { email });
  return res.data;
};

// ---- Chat (streaming) ----
export const streamChat = async (sessionId, message, onToken) => {
  const res = await fetch(`${API}/chat`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ session_id: sessionId, message }),
  });
  if (!res.ok || !res.body) throw new Error("Chat request failed");
  const reader = res.body.getReader();
  const decoder = new TextDecoder();
  while (true) {
    const { value, done } = await reader.read();
    if (done) break;
    const chunk = decoder.decode(value, { stream: true });
    if (chunk) onToken(chunk);
  }
};

// ---- Render (Blueprint -> 3D) ----
export const generateRender = async ({ prompt, angle, image_base64 }) => {
  const res = await authAxios.post(`/render`, { prompt, angle, image_base64 }, { timeout: 120000 });
  return res.data; // { id, angle, points }
};
export const renderImageUrl = (id) => `${API}/render/image/${id}`;

// ---- Auth ----
export const exchangeSession = async (sessionId) => {
  const res = await authAxios.post(`/auth/session`, { session_id: sessionId });
  return res.data;
};
export const getMe = async () => {
  const res = await authAxios.get(`/auth/me`);
  return res.data;
};
export const logout = async () => {
  const res = await authAxios.post(`/auth/logout`);
  return res.data;
};

// ---- Projects (protected) ----
export const saveProject = async (payload) => {
  const res = await authAxios.post(`/projects`, payload);
  return res.data;
};
export const listProjects = async () => {
  const res = await authAxios.get(`/projects`);
  return res.data;
};
export const deleteProject = async (id) => {
  const res = await authAxios.delete(`/projects/${id}`);
  return res.data;
};
export const updateProject = async (id, payload) => {
  const res = await authAxios.patch(`/projects/${id}`, payload);
  return res.data;
};

// ---- Share links (public) ----
export const createShare = async (payload) => {
  const res = await axios.post(`${API}/share`, payload);
  return res.data; // { slug }
};
export const getShare = async (slug) => {
  const res = await axios.get(`${API}/share/${slug}`);
  return res.data;
};

// ---- Material swaps (AI value engineering) ----
export const getSwaps = async ({ request, result }) => {
  const res = await axios.post(`${API}/estimate/swaps`, { request, result }, { timeout: 60000 });
  return res.data; // { swaps: [...] }
};

// ---- Payments (Stripe) ----
export const getPlans = async () => {
  const res = await axios.get(`${API}/payments/plans`);
  return res.data; // { plans, packs }
};
export const startCheckout = async (lookup_key) => {
  const res = await authAxios.post(`/payments/checkout`, { lookup_key, origin_url: window.location.origin });
  return res.data; // { checkout_url, session_id }
};
export const getPaymentStatus = async (session_id) => {
  const res = await axios.get(`${API}/payments/status/${session_id}`);
  return res.data;
};
